import { createAiHttp } from "./aiHttp";

const aiHttp = createAiHttp();

// Recursos compartilhados das artes de divulgação (diagnóstico, workshop, audiência pública)
class ArtworkService {
  // Logos configuradas da conta: [{ code, label, url }]
  GetLogos(contaId) {
    return aiHttp({ url: "/artwork/logos/" + contaId, method: "GET" });
  }
}

export default new ArtworkService();
